export const CART_URL ='/shop/api/ncart/';
export const CLEAR_CART_URL ='/shop/api/ncart/clear/';
export const DEL_ITEMS_URL ='/shop/api/ncart/';
export const UPDATE_ITEMS_URL ='/shop/api/ncart/';
export const ITEMS_URL ='/shop/api/ncart/fetch-dropdown/';
export const CHECKOUT_URL ='/shop/api/ncart/checkout/';

export const SHIPPING_COST_URL ='/shop/api/ncart/shippingcost/';
export const SHIPPING_URL ='/shop/api/ncart/shipping/';
export const USER_URL = '/shop/api/ncart/user/';

export const CART_EXCEL_FILE_DOWNLOAD = "/shop/api/ncart/excel_list/"
export const CART_EXCEL_FILE_UPLOAD = "/shop/api/ncart/excel_upload/"